import React from 'react';
import { Collapse, Divider, Fade, Paper } from '@mui/material';

import { useAppSelector } from '../../Store/hooks';
import { SelectShipment, SelectStatus } from '../../Store/Selectors';
import { ShipmentStatusViewComponent } from '../Shipment-Status-View/Shipment-Status-View.component';
import { StatusSubscription } from '../';
import { stageList } from '../../Models';
import './shipment-current-statuses.component.scss';

export const ShipmentCurrentStatusComponent: React.FC = () => {
    const statusState = useAppSelector(SelectStatus);
    const shipmentState = useAppSelector(SelectShipment);
    const isStatusVisible = !shipmentState.loading && !!statusState.statuses.length;
    const currentStatus = statusState.statuses?.at(-1);
    const isNotFound = String(currentStatus?.statusCode) === 'NOT_FOUND_HINT';

    return (
        <div className="shipment-current-status mt-sm-0">
            {!!isStatusVisible && !!currentStatus && !isNotFound && (
                <Collapse in={isStatusVisible} timeout={700}>
                    <Fade in={isStatusVisible} timeout={700}>
                        <Paper className="py-2 px-4 status-paper">
                            <Divider className="mb-3" />
                            <h3 className="my-2">Letzter Status</h3>
                            <Divider className="mb-2" />
                            <ShipmentStatusViewComponent
                                className="mb-2"
                                StatusDate={new Date(currentStatus.timeStamp ?? '')}
                                Statuses={[currentStatus]}
                                Carrier={statusState.carrier}
                            />

                            {currentStatus.stage !== stageList.Unzustellbar &&
                                currentStatus.stage !== stageList.Zugestellt &&
                                !['WA', 'ST'].includes(currentStatus.productTypeCode) &&
                                currentStatus.statusCode !== 990201 &&
                                String(currentStatus.statusCode) !== '990201' && (
                                    <StatusSubscription shipmentNumber={shipmentState.shipmentNumber} />
                                )}
                            <Divider className="mt-3" />
                        </Paper>
                    </Fade>
                </Collapse>
            )}
        </div>
    );
};
